import React, { useState } from 'react';
import PageContainer from 'src/components/container/PageContainer';
import DashboardCard from 'src/components/shared/DashboardCard';
import { Button, Grid, Snackbar} from '@mui/material';
import { Box } from '@mui/system';
// import CustomTextField from 'src/components/forms/theme-elements/CustomTextField';
// import TextEditor from 'src/components/CustomComponents/TextEditor';
// import { EditorState, convertToRaw } from 'draft-js';
// import ShowErrorMessage, { ShowSuccess } from 'src/components/CustomComponents/ShowMessages';
import { ShowSuccess } from 'src/components/CustomComponents/ShowMessages';
import ShowLoader from 'src/components/CustomComponents/ShowLoader';
// import { ReqField } from 'src/components/CustomComponents/CustomLoader';
// import { AddCircleOutlineRounded, AddCircleOutlined, CloseOutlined, CloseSharp, DeleteOutline } from '@mui/icons-material';
import { useMain } from '../hooks/useMain';
import TextInputs from 'src/components/inputs/TextInputs';

const initialValue = {
    productName: "",
    mrp: '',
    volume: '',
    unit: '',
    barcode: '',
    rewardPoints: '',
    branchDetails: "64883fdd9f0c66773facc3ba"
}


const AddProduct = () => {
    const [formData, setFormData] = useState(initialValue);
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [showLoader, setShowLoader] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value })
    }

    const { createProduct } = useMain();

    const handleSubmit = async () => {
        console.log({ ...formData });
        const { productName, barcode, rewardPoints, mrp, unit, volume } = formData;
        if (productName.trim() === '') return setErrorMessage('Product Name is Required');
        if (barcode === '') return setErrorMessage('Barcode is Required');
        if (rewardPoints === '') return setErrorMessage('Reward Points is Required');
        if (mrp === '') return setErrorMessage('MRP is Required');
        if (unit === '') return setErrorMessage('Unit is Required');
        if (volume === '') return setErrorMessage('Volume is Required');
        setShowLoader(true);

        const res = await createProduct(JSON.stringify(formData));

        if (res?.statusCode === 200) {
            setSuccessMessage('Product Successfully Created');
            setTimeout(() => {
                setSuccessMessage('');
            }, 7000);
            setFormData(initialValue);
            setErrorMessage('');
            setShowLoader(false);
        } else {
            setErrorMessage(res?.message);
            setTimeout(() => {
                setErrorMessage('');
            }, 7000);
            setFormData(initialValue);
            setShowLoader(false);
        }
    };
    return (
        <PageContainer title="Add New Product" description="this is add Product">
            <DashboardCard title="Add New Product">
                <Snackbar
                    // open={errorMessage == '' ? false : true}
                    open={errorMessage === '' ? false : true}
                    autoHideDuration={6000}
                    onClose={() => {
                        setErrorMessage('');
                    }}
                    severity="error"
                    message={errorMessage}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                />
                <Box style={{ marginTop: '20px' }}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={4}>
                            <TextInputs
                                title={'Product Name'}
                                name={'productName'}
                                value={formData?.productName}
                                handleChange={handleChange}
                                type={'text'}
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <TextInputs
                                title={'MRP'}
                                name={'mrp'}
                                value={formData?.mrp}
                                handleChange={handleChange}
                                type={'number'}
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <TextInputs
                                title={'Volume'}
                                name={'volume'}
                                value={formData?.volume}
                                handleChange={handleChange}
                                type={'number'}
                            />
                        </Grid>
                    </Grid>
                </Box>

                <Box style={{ marginTop: '20px' }}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={4}>
                            <TextInputs
                                title={'Unit'}
                                name={'unit'}
                                value={formData?.unit}
                                handleChange={handleChange}
                                type={'number'}
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <TextInputs
                                title={'Barcode'}
                                name={'barcode'}
                                value={formData?.barcode}
                                handleChange={handleChange}
                                type={'number'}
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <TextInputs
                                title={'Rewards Points Of Purchase'}
                                name={'rewardPoints'}
                                value={formData?.rewardPoints}
                                handleChange={handleChange}
                                type={'number'}
                            />
                        </Grid>
                    </Grid>
                </Box>
                {/* <Modal open={addVarientName} onClose={() => setAddVarientName(false)} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <div style={{ backgroundColor: 'white', padding: '5px 5px 10px 15px', outline: 'none', minWidth: '350px' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                            <div style={{ fontWeight: "bold" }}>Add Varient</div>
                            <IconButton onClick={() => setAddVarientName(false)}>
                                <CloseSharp />
                            </IconButton>
                        </div>
                        <TextField
                            label="Varient Name"
                            variant="outlined"
                            value={varientName}
                            style={{ marginBottom: '10px', width: '90%' }}
                            onChange={(e) => setVarientName(e.target.value)}
                        />
                        <div>
                            <Button style={{ display: "flex", justifyContent: "flex-end", }} variant="contained" color="primary" onClick={handleAddVarient}>
                                Add
                            </Button>
                        </div>
                    </div>
                </Modal> */}
                {/* <Box style={{ marginTop: '20px' }}>
                    <Typography
                        variant="subtitle1"
                        fontWeight={600}
                        component="label"
                        htmlFor="username"
                    >
                        Image1: <ReqField />
                    </Typography>
                    <div onClick={() => imageRef1.current.click()} style={{ cursor: 'pointer', border: '1px solid black', marginTop: '20px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%', borderRadius: '0.4rem', padding: '1rem' }}>
                        <div>
                            <input ref={imageRef1} type="file" onChange={(e) => handleImage(e, 'image1')} />
                        </div>
                        <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginTop: '10px' }}>
                            {showPreview?.image1 && <img alt='' height="100px" src={showPreview.image1} />}
                        </div>
                    </div>
                </Box>
                <Box style={{ marginTop: '20px' }}>
                    <Typography
                        variant="subtitle1"
                        fontWeight={600}
                        component="label"
                        htmlFor="username"
                    >
                        Image6:
                    </Typography>
                    <div onClick={() => imageRef6.current.click()} style={{ cursor: 'pointer', border: '1px solid black', marginTop: '20px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%', borderRadius: '0.4rem', padding: '1rem' }}>
                        <div>
                            <input ref={imageRef6} type="file" onChange={(e) => handleImage(e, 'image6')} />
                        </div>
                        <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginTop: '10px' }}>
                            {showPreview?.image6 && <img alt='' height="100px" src={showPreview.image6} />}
                        </div>
                    </div>
                </Box> */}

                {showLoader && <ShowLoader value={showLoader} />}
                {/* {successMessage != '' && <ShowSuccess message={successMessage} />} */}
                {successMessage !== '' && <ShowSuccess message={successMessage} />}

                <div style={{ width: '200px', margin: '3rem auto' }}>
                    <Button
                        variant="contained"
                        fullWidth
                        color="primary"
                        target="_blank"
                        sx={{
                            background: '#6174DD'
                        }}
                        onClick={handleSubmit}
                    >
                        Submit
                    </Button>
                </div>
            </DashboardCard>
        </PageContainer>
    )
}

export default AddProduct;